import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Block from "../components/Block";
import { projects } from "../data/projects";
import { useLang, pick } from "../i18n/LanguageContext";
import { t } from "../i18n/translations";

const Tyot = () => {
  const { lang } = useLang();
  const tr = pick(lang);
  // Toteutetut casetyöt ensin, kehitteillä olevat (upcoming) loppuun.
  const allProjects = [...projects.completed, ...projects.upcoming];
  const { hash } = useLocation();

  // Suora linkki casetyöhön (esim. /tyot#case-sun-effects tai /slush).
  // Sivunvaihdon häivytys vierittää ensin ylös, joten kohteeseen siirrytään
  // vasta kun case on renderöity.
  useEffect(() => {
    const id = decodeURIComponent((hash || "").slice(1));
    if (!id) return undefined;
    let tries = 0;
    let timer;
    const go = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      else if (tries++ < 20) timer = setTimeout(go, 100);
    };
    timer = setTimeout(go, 450);
    return () => clearTimeout(timer);
  }, [hash]);

  return (
    <article className="page page--tyot">
      <div className="page__inner">
        <header className="page__header">
          <h1 className="page__title">{tr(t.tyot.title)}</h1>
          <p className="page__intro">{tr(t.tyot.intro)}</p>
        </header>

        <section className="page__section">
          <h2 className="page__subtitle">{tr(t.tyot.productions)}</h2>
          {allProjects.length === 0 ? (
            <p className="grid__empty">{tr(t.tyot.empty)}</p>
          ) : (
            <div className="page__blocks">
              {allProjects.map((p, i) => {
                const tp = t.projects[p.id] || {};
                return (
                  <Block
                    key={p.id}
                    id={p.id}
                    media={
                      p.media && p.media.type === "carousel"
                        ? {
                            ...p.media,
                            items: p.media.items.map((item, idx) => ({
                              ...item,
                              label: tp.mediaLabels ? tr(tp.mediaLabels[idx]) : "",
                            })),
                          }
                        : p.media && p.media.type === "image" && tp.mediaAlt
                        ? { ...p.media, alt: tr(tp.mediaAlt) }
                        : p.media
                    }
                    headline={tr(tp.headline) || p.headline}
                    subheadline={tr(tp.subheadline) || p.subheadline}
                    body={tr(tp.body) || p.body}
                    body2={tr(tp.body2) || p.body2}
                    gallery={
                      p.gallery
                        ? p.gallery.map((row) =>
                            row.map((img) => ({
                              ...img,
                              alt: tp.galleryAlt
                                ? tr(tp.galleryAlt[img.altKey]) || ""
                                : "",
                            }))
                          )
                        : undefined
                    }
                    specs={
                      p.client
                        ? [
                            { label: tr(t.tyot.specClient), value: p.client },
                            { label: tr(t.tyot.specYear), value: p.year },
                          ]
                        : undefined
                    }
                  />
                );
              })}
            </div>
          )}
        </section>

        {/* Sivu ei pääty umpikujaan: kysymys ja yksi teko casejen jälkeen,
            toissijaisena palvelut, koska navbarissa ei ole sivulinkkejä. */}
        <section className="page__section page__cta">
          <h2 className="page__subtitle">{tr(t.tyot.ctaTitle)}</h2>
          <p className="page__intro">{tr(t.tyot.ctaBody)}</p>
          <div className="page__cta-links">
            <Link to="/yhteys" className="teaser__link">
              {tr(t.tyot.ctaLink)}
            </Link>
            <Link to="/palvelut" className="teaser__link">
              {tr(t.tyot.ctaServices)}
            </Link>
          </div>
        </section>
      </div>
    </article>
  );
};

export default Tyot;
